import { throwApiError } from '@/lib/errors';

const BACKEND_BASE = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';

export interface ReconDocSummary {
  id: number;
  project_id: number;
  title: string;
  source: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  total_parts: number | null;
  received_parts: number;
  is_complete: boolean;
}

export interface ReconDocDetail extends ReconDocSummary {
  content: string;
  missing_parts: number[];
}

export const reconDocService = {
  list: async (projectId: number): Promise<ReconDocSummary[]> => {
    const response = await fetch(`${BACKEND_BASE}/api/recon-docs/${projectId}`, {
      credentials: 'include',
    });
    if (!response.ok) {
      await throwApiError(response, 'Failed to load recon docs');
    }
    return response.json();
  },

  get: async (projectId: number, docId: number): Promise<ReconDocDetail> => {
    const response = await fetch(`${BACKEND_BASE}/api/recon-docs/${projectId}/${docId}`, {
      credentials: 'include',
    });
    if (!response.ok) {
      await throwApiError(response, 'Failed to load recon doc');
    }
    return response.json();
  },

  remove: async (docId: number): Promise<void> => {
    const response = await fetch(`${BACKEND_BASE}/api/recon-docs/${docId}`, {
      method: 'DELETE',
      credentials: 'include',
    });
    if (!response.ok) {
      await throwApiError(response, 'Failed to delete recon doc');
    }
  },
};
